var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-thumbnail",class:{ small: _vm.size === 'sm', medium: _vm.size === 'md' },style:('background-image: url(' + _vm.url + ')')})}
var staticRenderFns = []

export { render, staticRenderFns }